<template>
  <div class="page product-apply">
    <div class="container">
      <van-form ref="applyForm" @submit="pay">
        <van-cell-group inset>
          <h3>订单信息</h3>
          <van-cell :border="false">
            <template #title>
              <span>订单号：</span>{{ payOrderInfo.mchOrderNo }}
            </template>
          </van-cell>

          <van-cell :border="false">
            <template #title>
              <span>下单时间：</span>{{ payOrderInfo.createdAt }}
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset>
          <h3>选择支付方式</h3>
          <van-radio-group v-model="payType">
            <van-cell-group class="paytype-radio-group" :border="false">
              <van-cell title="支付宝支付" clickable @click="payType = '1'">
                <van-icon
                  size="24"
                  :name="wxImg"
                  class="radio-icon"
                  color="#09bb07"
                />
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-cell-group>
      </van-form>
    </div>
    <div class="end">
      <div class="settle">
        <van-button
          native-type="submit"
          type="info"
          round
          class="settle-submit"
          @click="pay"
          :loading="loading"
          >确认支付</van-button
        >
        支付金额：<strong>{{ payOrderInfo.amount / 100 }}元</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayPackage, getPayOrderInfo } from "@/api/api";
import config from "@/config";
export default {
  data: function () {
    return {
      merchantName: "jeepay", // 付款的商户默认
      avatar: require("../../assets/images/zfb.jpeg"), // 商户头像默认
      amount: 1, // 支付金额默认
      resData: {},
      wxImg: require("../../assets/images/zfb.jpeg"), // 微信支付图片
      payOrderInfo: {}, //订单信息
      loading: false,
      payType: "1",
    };
  },

  mounted() {
    this.setPayOrderInfo(false); //获取订单信息 & 调起支付插件
  },

  methods: {
    setPayOrderInfo(isAutoPay) {
      const that = this;
      getPayOrderInfo()
        .then((res) => {
          that.payOrderInfo = res;

          if (isAutoPay) {
            that.pay();
          }
        })
        .catch((res) => {
          that.$router.push({
            name: config.errorPageRouteName,
            params: { errInfo: res.msg },
          });
        });
    },

    pay: function () {
      let that = this;
      this.loading = true;
      getPayPackage(this.amount)
        .then((res) => {
          this.loading = false;
          //订单创建异常
          if (res.code != "0") {
            return alert(res.msg);
          }

          if (res.data.orderState != 1) {
            //订单不是支付中，说明订单异常
            return alert(res.data.errMsg);
          }
          //alert(JSON.stringify(res));
          if (res.data.payUrl) {
            window.location.replace(res.data.payUrl);
            return false;
          } else {
            let tradeNo = res.data.alipayTradeNo?res.data.alipayTradeNo:res.data.payInfo;
            if (!window.AlipayJSBridge) {
              document.addEventListener(
                "AlipayJSBridgeReady",
                function () {
                  that.doAlipay(tradeNo);
                },
                false
              );
            } else {
              that.doAlipay(tradeNo);
            }
          }
        })
        .catch((res) => {
          this.loading = false;
          that.$router.push({
            name: config.errorPageRouteName,
            params: { errInfo: res.msg },
          });
        });
    },

    doAlipay(alipayTradeNo) {
      const that = this;

      // eslint-disable-next-line no-undef
      AlipayJSBridge.call(
        "tradePay",
        {
          tradeNO: alipayTradeNo,
        },
        function (data) {
          if ("9000" == data.resultCode) {
            // alert('支付成功！');

            // //重定向
            if (that.payOrderInfo.returnUrl) {
              location.href = that.payOrderInfo.returnUrl;
            } else {
              alert("支付成功！");
              window.AlipayJSBridge.call("closeWebview");
            }

            //‘8000’：后台获取支付结果超时，暂时未拿到支付结果;
            // ‘6004’：支付过程中网络出错， 暂时未拿到支付结果;
          } else if ("8000" == data.resultCode || "6004" == data.resultCode) {
            //其他

            alert(JSON.stringify(data));
            window.AlipayJSBridge.call("closeWebview");
          } else {
            ///其他异常信息， 需要取消订单
            alert("用户已取消！");
            window.AlipayJSBridge.call("closeWebview");
          }
        }
      );
    },
  },
};
</script>
<style lang="css" scoped>
@import "./pay.css";
</style>

<style lang="scss" scoped>
.page {
  background-color: #f8f9fb;
}
.product-apply {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.container {
  flex: 1;
  overflow: auto;
  color: #111a34;
  .van-cell-group--inset,
  .insureAdd {
    margin: 10px 16px;
    padding-bottom: 10px;
  }
  .insureAdd {
    margin: 0 16px 16px;
    width: 343px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    color: #1e92ff;
  }
  h3 {
    margin: 16px 0 12px 14px;
    line-height: 24px;
    font-size: 18px;
    color: #121130;
    em {
      position: absolute;
      margin-top: 4px;
      margin-left: 5px;
      display: inline-block;
      min-width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #fff;
      background-color: #1e92ff;
      border-radius: 9px;
    }
  }
  p {
    line-height: 24px;
    font-size: 14px;
  }
}
// 尾部固定
.end {
  position: relative;
  z-index: 9;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}
.settle,
.settle-submit {
  line-height: 40px;
  overflow: hidden;
}
.settle {
  width: 100%;
  height: 72px;
  padding: 14px 16px 14px 20px;
  font-size: 14px;
  box-sizing: border-box;
  strong {
    font-size: 16px;
    color: #f00;
  }
  .settle-submit {
    float: right;
    height: 40px;
  }
  .van-button__text {
    padding: 0 10px;
  }
}
.paytype-radio-group {
  .van-cell__value {
    position: absolute;
  }
  .van-cell__title {
    padding-left: 30px;
    font-size: 16px;
  }
}
</style>